module.exports = __webpack_public_path__ + "static/img/female.92033031.png";